"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps } from "../../lib/inspector";
import { TextSection, type TextSectionProps } from "./text-section";

export type TextSectionInspectorProps = BlockInspectorProps;

export function TextSectionPreview(props: Readonly<TextSectionProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const headlineInspector = useContentfulInspectorMode({
    entryId: props.headline?.sys?.id,
    locale: props.headline?.sys?.locale,
  });

  const textInspector = useContentfulInspectorMode({
    entryId: props.text?.sys?.id,
    locale: props.text?.sys?.locale,
  });

  return (
    <TextSection
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        headline: headlineInspector({ fieldId: "headline" }) ?? undefined,
        text: textInspector({ fieldId: "text" }) ?? undefined,
      }}
    />
  );
}
